import React from 'react'
import Server from 'components/Server'

export default Component => props => (
  <Server render={({ server }) => <Component server={server} {...props} />} />
)



// WEBPACK FOOTER //
// ./src/components/withServer.js